"use strict";
/**
 * AI 建站的契约。
 *
 * ## 为什么只有三个"面"
 *
 * 用户看到的是三屏：填四格 → 看进度 → 收交付。中间**没有可编辑的蓝图**，
 * 所以这里没有 `/plan` 的请求/响应，蓝图只存在于「运行」这一条记录里
 * （`brief`），前端不往返、也不展示。
 *
 * ## 为什么 brand-suggest 单独一条
 *
 * 品牌名是唯一一个"用户可能真的不知道"的字段。它是对话里的一轮追问，
 * 不是一步流程，所以无状态、不落库、不占 run —— 用户接受了名字，
 * 那个字符串随 `/runs` 的 `brand` 一起进来。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SITE_AGENT_STATUS_LABEL = void 0;
exports.SITE_AGENT_STATUS_LABEL = {
    queued: '排队中',
    building: '正在创建站点',
    art: '正在生成配图',
    done: '已完成',
    failed: '未完成',
};
//# sourceMappingURL=site-agent.js.map